var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 183,
    viewBox: "0 0 327 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200.05,
    cy: 276.163,
    r: 305.613,
    fill: "url(#paint0_linear_16243_13176)",
    fillOpacity: 0.3,
    stroke: "url(#paint1_radial_16243_13176)",
    strokeWidth: 0.631655
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.9285,
    cy: 143.928,
    r: 305.613,
    fill: "url(#paint2_linear_16243_13176)",
    fillOpacity: 0.4,
    stroke: "url(#paint3_radial_16243_13176)",
    strokeWidth: 0.631655
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16243_13176",
    x1: 200.05,
    y1: -29.7656,
    x2: 200.05,
    y2: 582.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E691D2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E691D2",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16243_13176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.05 276.163) rotate(89.968) scale(633.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B50DAA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD1FB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16243_13176",
    x1: 23.9285,
    y1: -162,
    x2: 23.9285,
    y2: 449.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E691D2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E691D2",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16243_13176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9285 143.928) rotate(89.968) scale(633.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B50DAA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD1FB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaLite);
export default __webpack_public_path__ + "static/media/triva_lite.354f168857c80f7617aaa6b635dd9079.svg";
export { ForwardRef as ReactComponent };